export default __webpack_public_path__ + "static/media/kepler.041ed088.svg";